import {omit} from 'ramda';

import type {FeGridSettings} from '../types/Api';

const LOCAL_GRID_SETTING_KEYS = [
  'emptyCellValueMode',
  'truncatedCellHoverMode',
  'headerWrapMode',
  'activeFilterBarVisible',
  'confirmSortReplacement',
  'paginationDisplayMode',
  'presetDisplayMode',
] as const;

export type LocalGridSettings = Pick<FeGridSettings, (typeof LOCAL_GRID_SETTING_KEYS)[number]>;

/** Local display preferences must not affect preset dirty checks or API payloads. */
export const stripLocalGridSettings = (settings: FeGridSettings): FeGridSettings =>
  omit(LOCAL_GRID_SETTING_KEYS, settings);
